import { Divider, Stack } from '@mui/material';
import { Treatments } from './Treatments';
import { Languages } from './Languages';
import { SpecialServices } from './SpecialServices';
import { useIsDesktop } from 'Hooks';
import { MoreContactDetails } from './MoreContactDetails';
import { ISuppliersResult } from 'API/Suppliers/suppliers';
import { supplierResourceFilterMapper } from 'Utils/suppliersResources';
import { useContext } from 'react';
import { TherapySuppliersContext } from 'Context/SuppliersContext/TherapySuppliersContext';

interface IDetails {
  data: ISuppliersResult;
}

export const Details = ({ data }: IDetails) => {
  const { resources } = useContext(TherapySuppliersContext);
  const isDesktop = useIsDesktop();

  const treatmentMethods: string[] = supplierResourceFilterMapper(
    resources.GISHA,
    data.treatmentMethods
  );

  const languages: string[] = supplierResourceFilterMapper(
    resources.LNGCD,
    data.languages
  );

  const services: boolean[] = [
    data.hasAccessibilityForHandicapped,
    data.hasHomeVisit,
  ];

  const homePhoneNumber: string | null =
    data.homePhonePrefix && data.homePhoneNumber
      ? `${data.homePhonePrefix}-${data.homePhoneNumber}`
      : null;

  return (
    <>
      {isDesktop && (
        <Divider
          orientation='horizontal'
          sx={{ mb: '24px', borderColor: 'primary.shade_100' }}
          aria-hidden={true}
        />
      )}
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? undefined : '20px'}
        sx={{
          mb: isDesktop ? undefined : '20px',
        }}
      >
        <SpecialServices services={services} />
        <Treatments treatmentMethods={treatmentMethods} />
      </Stack>
      {isDesktop &&
        (treatmentMethods.length > 0 ||
          languages.length > 0 ||
          services.some((service: boolean) => service === true)) && (
          <Divider
            orientation='horizontal'
            sx={{ m: '24px 0', borderColor: 'primary.shade_100' }}
            aria-hidden={true}
          />
        )}
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? undefined : '20px'}
      >
        <Languages languagesList={languages} />
        {(data.email || homePhoneNumber) && (
          <MoreContactDetails
            homePhoneNumber={
              data.cellPhonePrefix && data.cellPhoneNumber
                ? homePhoneNumber
                : null
            }
            email={data.email}
          />
        )}
      </Stack>
    </>
  );
};
